export const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:4252/api';

export async function parseResponse(response) {
  const contentType = response.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    const payload = await response.json();
    if (!response.ok) {
      throw new Error(payload.error || 'Request failed.');
    }

    return payload;
  }

  const text = await response.text();
  if (!response.ok) {
    throw new Error(text || 'Request failed.');
  }

  return text;
}
